import React, { useEffect, useState } from 'react';

export const CountdownTimer = ({ endDate }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = new Date(endDate) - new Date();
    if (difference <= 0) {
      return { ended: true };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  if (timeLeft.ended) {
    return (
      <div className="inline-flex items-center gap-2 font-mono text-sm font-bold text-destructive bg-destructive/10 px-3 py-1 rounded-sm" data-testid="auction-ended">
        ENDED
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 font-mono text-sm font-bold text-destructive bg-destructive/10 px-3 py-1 rounded-sm" data-testid="countdown-timer">
      <span className="tabular-nums">
        {timeLeft.days > 0 && `${timeLeft.days}d `}
        {String(timeLeft.hours).padStart(2, '0')}:
        {String(timeLeft.minutes).padStart(2, '0')}:
        {String(timeLeft.seconds).padStart(2, '0')}
      </span>
    </div>
  );
};
